import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var FetchError = /*#__PURE__*/function (_Error) {
  _inherits(FetchError, _Error);
  var _super = _createSuper(FetchError);
  function FetchError(response, resBody) {
    var _this;
    _classCallCheck(this, FetchError);
    _this = _super.call(this, "[FetchError] Request failed with status ".concat(response.status, " and statusMessage=").concat(response.statusText));
    _this.status = response.status;
    _this.response = response;
    _this.responseBody = resBody;
    _this.name = _this.constructor.name;
    return _this;
  }
  return _createClass(FetchError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
function removeEmptyProp(obj) {
  var result = _objectSpread({}, obj);
  Object.entries(result).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      val = _ref2[1];
    if (val === undefined || val === null) {
      // @ts-ignore (TS7053)
      delete result[key];
    }
  });
  return result;
}

// In docs of fetch API, https://developer.mozilla.org/en/docs/Web/API/Fetch_API,
// fetch just throw error for network error, it does not throw error for server error like 400,...
function handleFetchCommonResponse(_x) {
  return _handleFetchCommonResponse.apply(this, arguments);
}
function _handleFetchCommonResponse() {
  _handleFetchCommonResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
    var resBody;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (res.ok) {
            _context.next = 10;
            break;
          }
          _context.prev = 1;
          _context.next = 4;
          return res.json();
        case 4:
          resBody = _context.sent;
          _context.next = 9;
          break;
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](1);
        case 9:
          throw new FetchError(res, resBody);
        case 10:
          return _context.abrupt("return", res);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 7]]);
  }));
  return _handleFetchCommonResponse.apply(this, arguments);
}
export var getCustomResolversFetch = function getCustomResolversFetch(_ref3) {
  var fetch = _ref3.fetch,
    _ref3$statusCodeHandl = _ref3.statusCodeHandlers,
    statusCodeHandlers = _ref3$statusCodeHandl === void 0 ? {} : _ref3$statusCodeHandl;
  return function (url) {
    var fetchOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var headers = _objectSpread({
      'Content-Type': 'application/json'
    }, fetchOptions.headers);
    return fetch(url, _objectSpread(_objectSpread({
      credentials: 'include'
    }, fetchOptions), {}, {
      headers: removeEmptyProp(headers)
    })).then(function (response) {
      var status = response.status;
      var handler = statusCodeHandlers[status];
      if (typeof handler === 'function') {
        handler(response);
      }
      return response;
    }).then(handleFetchCommonResponse);
  };
};